import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { StoreState } from '../../../../redux/reducers/store.types';
import { Dispatch } from '../../../../redux/redux.types';
import { openTeamMemberDeleteModalFromEditModal } from '../../team.actions';
import {
  getEditingTeamMemberAvatarUrl,
  getEditingTeamMemberEmail,
  getEditingTeamMemberName,
  getEditingTeamMemberSecurityGroups,
} from '../../team.selectors-ui';
import { TeamMemberEditFormValues } from '../../team.types';
import { editTeamMember } from '../team-member-form/team-member-form.actions';
import { generateSecurityGroups } from '../team-member-form/team-member-form.utils';

import {
  TeamMemberEditFormComponent,
  TeamMemberEditFormOwnProps,
  TeamMemberEditFormProps,
} from './team-member-edit-form';

export const TEAM_MEMBER_EDIT_FORM_NAME = 'teamMemberEditForm';

export const TeamMemberEditForm = compose<
  TeamMemberEditFormProps,
  TeamMemberEditFormOwnProps
>(
  connect(
    (state: StoreState) => ({
      teamMemberAvatarUrl: getEditingTeamMemberAvatarUrl(state),
      teamMemberEmail: getEditingTeamMemberEmail(state),
      teamMemberName: getEditingTeamMemberName(state),
      initialValues: {
        securityGroups: getEditingTeamMemberSecurityGroups(state),
      },
    }),
    (dispatch: Dispatch) => ({
      onSubmit: (formData: TeamMemberEditFormValues) =>
        dispatch(
          editTeamMember(generateSecurityGroups(formData.securityGroups)),
        ),
      openTeamMemberDeleteModal: () =>
        dispatch(openTeamMemberDeleteModalFromEditModal()),
    }),
  ),
  injectIntl,
)(TeamMemberEditFormComponent);
